var _rect, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _circle2, _circle3, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _circle4, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadcastMessageShowcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    rx: 30,
    fill: "#EEF1FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 900,
    fill: "url(#paint0_linear)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 18,
    fill: "#F8FAFC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 19,
    width: 110,
    height: 10,
    rx: 5,
    fill: "#F8FAFC",
    fillOpacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 34,
    width: 140,
    height: 14,
    rx: 7,
    fill: "#F8FAFC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 52,
    width: 148,
    height: 24,
    rx: 12,
    fill: "#16375F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 740,
    width: 280,
    height: 160,
    fill: "#172238"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 138,
    width: 250,
    height: 44,
    rx: 16,
    fill: "url(#paint1_linear)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 147,
    width: 140,
    height: 12,
    rx: 6,
    fill: "#F8FAFC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 195,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#AEB6CC"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 196,
    width: 102,
    height: 12,
    rx: 6,
    fill: "#F8FAFC"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 243,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#AEB6CC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 244,
    width: 132,
    height: 12,
    rx: 6,
    fill: "#F8FAFC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 291,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#AEB6CC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 292,
    width: 126,
    height: 12,
    rx: 6,
    fill: "#F8FAFC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 339,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#AEB6CC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 340,
    width: 140,
    height: 12,
    rx: 6,
    fill: "#F8FAFC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 24,
    width: 58,
    height: 8,
    rx: 4,
    fill: "#7C8499"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 20,
    width: 168,
    height: 22,
    rx: 10,
    fill: "#E4E7FB"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 24,
    width: 78,
    height: 8,
    rx: 4,
    fill: "#7C8499"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 24,
    width: 88,
    height: 8,
    rx: 4,
    fill: "#7C8499"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 24,
    width: 132,
    height: 8,
    rx: 4,
    fill: "#7C8499"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 970,
    y: 24,
    width: 132,
    height: 8,
    rx: 4,
    fill: "#7C8499"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1126,
    y: 24,
    width: 64,
    height: 8,
    rx: 4,
    fill: "#7C8499"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1508,
    cy: 30,
    r: 18,
    fill: "#E4E7FB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1548,
    cy: 30,
    r: 18,
    fill: "#D8DBEA"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 72,
    width: 246,
    height: 18,
    rx: 9,
    fill: "#20263B"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 104,
    width: 278,
    height: 10,
    rx: 5,
    fill: "#667085"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1452,
    y: 80,
    width: 118,
    height: 28,
    rx: 14,
    fill: "#D94848"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 172,
    width: 190,
    height: 12,
    rx: 6,
    fill: "#667085"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 202,
    width: 112,
    height: 36,
    rx: 10,
    fill: "#FFFFFF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 202,
    width: 124,
    height: 36,
    rx: 10,
    fill: "#EEF1FE"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 202,
    width: 114,
    height: 36,
    rx: 10,
    fill: "#EEF1FE"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 274,
    width: 180,
    height: 12,
    rx: 6,
    fill: "#667085"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 306,
    width: 280,
    height: 92,
    rx: 16,
    fill: "#FFFFFF"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 602,
    y: 306,
    width: 280,
    height: 92,
    rx: 16,
    fill: "#FFFFFF"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 898,
    y: 306,
    width: 280,
    height: 92,
    rx: 16,
    fill: "#FFFFFF"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 448,
    width: 180,
    height: 12,
    rx: 6,
    fill: "#667085"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 480,
    width: 750,
    height: 412,
    rx: 22,
    fill: "#FFFFFF"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 506,
    width: 686,
    height: 42,
    rx: 12,
    fill: "#F7F9FE",
    stroke: "#D6DEEF"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 570,
    width: 686,
    height: 160,
    rx: 12,
    fill: "#F7F9FE",
    stroke: "#D6DEEF"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 780,
    width: 686,
    height: 124,
    rx: 18,
    stroke: "#B8C2DE",
    strokeDasharray: "8 8"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1174,
    y: 176,
    width: 184,
    height: 16,
    rx: 8,
    fill: "#667085"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1168,
    y: 244,
    width: 336,
    height: 570,
    rx: 54,
    fill: "#111111"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 1186,
    y: 262,
    width: 300,
    height: 534,
    rx: 34,
    fill: "url(#paint2_linear)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 1278,
    y: 262,
    width: 116,
    height: 24,
    rx: 12,
    fill: "#111111"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 1302,
    y: 332,
    width: 68,
    height: 18,
    rx: 9,
    fill: "#FFFFFF"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 384,
    width: 220,
    height: 96,
    rx: 14,
    fill: "#FFFFFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1230,
    cy: 408,
    r: 12,
    fill: "#5B5CE6"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 398,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#667085"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 1398,
    y: 398,
    width: 26,
    height: 10,
    rx: 5,
    fill: "#9AA4B8"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 434,
    width: 126,
    height: 14,
    rx: 7,
    fill: "#B8C2DE"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 458,
    width: 170,
    height: 12,
    rx: 6,
    fill: "#D5DBEA"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 807,
    width: 110,
    height: 10,
    rx: 5,
    fill: "#A1A8BF"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 744,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#C7CEF0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 280,
    y2: 900,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10192C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16,
    y1: 138,
    x2: 266,
    y2: 182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323E8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B4D74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1186,
    y1: 262,
    x2: 1486,
    y2: 796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4648C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6681"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastMessageShowcase);
export default __webpack_public_path__ + "static/media/broadcast-message-showcase.0e533aaf034055396ca793354954f9a6.svg";
export { ForwardRef as ReactComponent };